import { Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

// Generic column/row grid - the real column count isn't known until the feature columns resolve.
const columnCount = 8;
const rowCount = 8;

export default function OrderingProductsTableSkeleton() {
    return (
        <TableContainer
            component={Paper}
            sx={{
                borderRadius: 2,
                boxShadow: 3,
                margin: '1rem 1rem 1rem 0rem',
                width: '100%',
            }}
        >
            <Table sx={{ width: '100%' }}>
                <TableHead>
                    <TableRow>
                        {[...Array(columnCount)].map((_, index) => (
                            <TableCell key={index}>
                                <Skeleton variant="text" width="80%" />
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {[...Array(rowCount)].map((_, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {[...Array(columnCount)].map((_, columnIndex) => (
                                <TableCell key={columnIndex}>
                                    <Skeleton variant="text" />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
